export function create404Error() {
  return createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: false, // This prevents it from being logged as an error
  });
}
